import { render } from "./TDRL.vue?vue&type=template&id=6be3da7e"
import script from "./TDRL.vue?vue&type=script&lang=js"
export * from "./TDRL.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__